import React from 'react';
// import Box from '@material-ui/core/Box';
import InspirationIcon from 'assets/ssc_inspiration.png';
import SuccessIcon from 'assets/ssc_success.png';
import PurchaseIcon from 'assets/ssc_purchase.png';
import HintCard from './HintCard';
import ContentTypography from '../../../Common/ContentTypography';
import Styles from './index.module.css';

function HintDashboard() {
  return (
    <div className={Styles.hintDashboardContainer}>
      <div className={Styles.hintDashboardCard}>
        <ContentTypography style={{ fontSize: '18px' }}>沒有靈感?</ContentTypography>
      </div>
      <div className={Styles.hintDashboardCard}>
        <HintCard src={InspirationIcon}>素材靈感</HintCard>
      </div>
      <div className={Styles.hintDashboardCard}>
        <HintCard src={SuccessIcon}>成功案例</HintCard>
      </div>
      <div className={Styles.hintDashboardCard}>
        <HintCard src={PurchaseIcon}>加購素材</HintCard>
      </div>
    </div>

  );
}

export default HintDashboard;
